import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-8 lg:gap-15',
    block: '',
    actions: 'mt-7 flex justify-between gap-10 pr-4.5 max-md:hidden',
    labels: 'flex flex-wrap gap-1',
    share: '',
    stock:
      'heading-xs relative mb-4 cursor-pointer pl-4 before:absolute before:top-1/2 before:-left-0 before:block before:h-2.5 before:w-2.5 before:-translate-y-1/2 before:transform before:rounded-full disabled:cursor-default',
    addToCart: 'flex-1',
    wishlist: 'flex-center flex size-[50px]',
    wishlistIcon: 'size-6 md:size-10',
    price: 'mb-[5px] items-baseline',
    loyalty: '',
    name: 'flex flex-col',
    nameText: 'block',
    shortDescription: 'block',
    image: 'bg-accent',
    link: 'heading-xs-bold tracking-[0.06em] uppercase',
    info: '',
    sku: 'tracking-0 text-text-inactive heading-s leading-1.4 md:heading-m mt-1.5 md:tracking-[0.6px]',
    compare: 'size-6 group-hover/tile:opacity-100 md:size-10',
    compareIcon: 'h-full w-full',
    itemActions: 'flex items-center gap-6',
    shipping: 'heading-m leading-1.4 tracking-[0.5px]',
    shippingLbl:
      'hover:text-brand-400 cursor-pointer underline underline-offset-3'
  },
  variants: {
    catalog: {
      true: {
        labels: 'mb-2',
        nameText: 'heading-m lg:heading-xl mb-1',
        shortDescription: 'heading-xs lg:heading-s',
        image: 'h-25 w-25 bg-white object-contain lg:h-30 lg:w-30',
        info: 'mb-4 flex gap-5'
      },
      false: {
        labels: 'mb-2.5 lg:mb-4',
        nameText: 'heading-2xl lg:heading-3xl mb-2 font-medium lg:font-medium',
        shortDescription: 'heading-s lg:heading-m mb-2.5 lg:mb-5.5'
      }
    },
    outOfStock: {
      true: {
        stock: 'before:bg-[#E25444]',
        price: 'opacity-50',
        loyalty: 'opacity-50'
      },
      false: {
        stock: 'before:bg-[#34AD69]'
      }
    }
  }
});
